"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/web.ts
var web_exports = {};
__export(web_exports, {
  decodeEchoOSSUrl: () => decodeEchoOSSUrl,
  decodeEchoOSSUrlInterceptor: () => decodeEchoOSSUrlInterceptor,
  encodeEchoOSSUrlInterceptor: () => encodeEchoOSSUrlInterceptor,
  encodeOSSUrl: () => encodeOSSUrl,
  genOSSUpload: () => genOSSUpload,
  getCDNUrlWithoutImgInfo: () => getCDNUrlWithoutImgInfo,
  getImgInfoFromUrl: () => getImgInfoFromUrl,
  getSceneMapFn: () => getSceneMapFn,
  init: () => init
});
module.exports = __toCommonJS(web_exports);

// src/lib/const.ts
var ONE_MB_UNIT = 1024 * 1024 * 1;
var snapshotOssQuery = "!snapshot";
var videoExtList = [
  "3g2",
  "3gp",
  "aaf",
  "asf",
  "avchd",
  "avi",
  "drc",
  "flv",
  "m2v",
  "m3u8",
  "m4p",
  "m4v",
  "mkv",
  "mng",
  "mov",
  "mp2",
  "mp4",
  "mpe",
  "mpeg",
  "mpg",
  "mpv",
  "mxf",
  "nsv",
  "ogg",
  "ogv",
  "qt",
  "rm",
  "rmvb",
  "roq",
  "svi",
  "vob",
  "webm",
  "wmv",
  "yuv"
];

// src/web.ts
var import_axios = __toESM(require("axios"));

// src/lib/config.ts
var DATA = "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";
var config_default = DATA;

// src/lib/decodedConfig.ts
var SCENE_MAP = true ? JSON.parse(require("lz-string").decompressFromBase64(config_default)) : {
  whitePathList: [],
  hostList: []
};
var decodedConfig_default = SCENE_MAP;

// src/lib/utils.ts
var import_url_pattern = __toESM(require("url-pattern"));
var import_url_parse = __toESM(require("url-parse"));
var hostList = ["cdn.qiandaoapp.com", "images.qiandaocdn.com"];
var revertSceneMap = {
  "interior/images": {
    host: "https://dev-cdn.qiandaoapp.com"
  }
};
var pathList = [];
var sceneMap = decodedConfig_default;
var getRealScene = (scene, isProd = true) => {
  if (!isProd) {
    let rest = scene.split(".");
    rest.splice(1, 0, "dev");
    const newScene = rest.join(".");
    scene = newScene;
  }
  return scene;
};
var urlRegexp = /http[s]:\/\/([a-zA-Z0-9-.]+)\/([a-zA-Z0-9-./_]+)/g;
var encodeOssUrl = (url, getSceneMapFn2 = getSceneMap, force = false) => {
  try {
    if (!url) {
      return url;
    }
    const sceneMap2 = getSceneMapFn2();
    if (isEmptyObj(sceneMap2)) {
      console.error("eros: get an empty sceneMap");
      return url;
    }
    const result = url.replace(urlRegexp, (match, host, path) => {
      var _a;
      try {
        if (!hostList.includes(host)) {
          return match;
        }
        const slashArray = path.split("/");
        const hash = slashArray.pop();
        const mainPath = slashArray.join("/");
        console.debug({ mainPath, host, match });
        if (pathList.includes(mainPath)) {
          return match;
        }
        const sceneValue = (_a = revertSceneMap == null ? void 0 : revertSceneMap[mainPath]) == null ? void 0 : _a.find(
          (s) => s.sHost === host
        );
        if (!sceneValue) {
          console.error(
            `eros: secneValue is empty. ${{
              mainPath,
              match,
              revertSceneMap
            }}; `
          );
          return match;
        }
        const { isReturnOSSUrl, sceneKey } = sceneValue;
        if (!isReturnOSSUrl && !force) {
          return match;
        }
        return `echotechoss://${sceneKey}/${hash}`;
      } catch (error) {
        console.error(error);
        return match;
      }
    });
    return result;
  } catch (error) {
    console.error("Eros encodeOSSUrl error", error);
    return url;
  }
};
function parsePath(path, data) {
  try {
    const pattern = new import_url_pattern.default(path);
    const { names } = pattern;
    if (!names.length) {
      return path;
    }
    if (!data || !Object.keys(data).length) {
      throw new Error(
        "Eros:: upload SDK parsePath error, expect data not empty"
      );
    }
    const realPath = pattern.stringify(data);
    return realPath;
  } catch (error) {
    console.error(error);
  }
}
var travel = (data, func) => {
  const find = (data2) => {
    if (data2 && typeof data2 === "object" && isEmptyObj(data2)) {
      return data2;
    }
    if (data2 && isObject(data2)) {
      return Object.keys(data2).reduce(
        (acc, cur) => {
          let value = data2[cur];
          value = find(value);
          acc[cur] = value;
          return acc;
        },
        {}
      );
    }
    if (Array.isArray(data2)) {
      return data2.map(find);
    }
    if (data2 && typeof data2 === "string" && toType(data2) === "string") {
      return func(data2);
    }
    return data2;
  };
  return find(data);
};
var toType = function(obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
function isObject(obj) {
  return toType(obj) === "object";
}
function isEmptyObj(obj) {
  return toType(obj) === "object" && Object.keys(obj).length === 0;
}
var echoUrlRegexp = /echotechoss:\/\/([a-zA-Z0-9-.]+)\/([a-zA-Z0-9-.\/_]+)(\?(?!.*echotechoss)[^"#\s]*)?/g;
var transform = (url, getSceneMapFn2 = getSceneMap, force = false) => {
  try {
    if (!url) {
      return url;
    }
    if (toType(url) !== "string") {
      return url;
    }
    const sceneMap2 = getSceneMapFn2();
    if (isEmptyObj(sceneMap2)) {
      console.error("eros: get an empty sceneMap");
      return url;
    }
    return url.replace(echoUrlRegexp, (match) => {
      const parseUrl = new import_url_parse.default(match);
      const sceneItem = sceneMap2[parseUrl.host];
      if (!sceneItem)
        return match;
      if (!sceneItem.isDecode && !force) {
        return match;
      }
      let queryObj = {};
      let realPath = sceneItem.path;
      let queryString = "";
      if (parseUrl.query.length > 0) {
        const rawQuery = parseUrl.query.slice(1);
        queryObj = rawQuery.split("&").reduce((acc, cur) => {
          const [k, v] = cur.split("=");
          if (realPath.includes(`:${k}`)) {
            realPath = realPath.replace(`:${k}`, v);
          } else {
            acc[k] = v;
          }
          return acc;
        }, queryObj);
        const queryLen = Object.keys(queryObj).length;
        if (queryLen > 0) {
          queryString = Object.keys(queryObj).reduce((acc, cur, idx) => {
            acc += `${cur}=${queryObj[cur]}${idx === queryLen - 1 ? "" : "&"}`;
            return acc;
          }, "?");
        }
      }
      const res = `${sceneItem.host}/${realPath}${parseUrl.pathname}${queryString.length > 0 ? queryString : ""}`;
      return res;
    });
  } catch (error) {
    console.error(error);
    return url;
  }
};
var mergeConfig = (data) => {
  const _a = data, { whitePathList = [], hostList: remoteHostList } = _a, map = __objRest(_a, ["whitePathList", "hostList"]);
  sceneMap = __spreadValues(__spreadValues({}, sceneMap), map);
  pathList = Array.from(/* @__PURE__ */ new Set([...pathList, ...whitePathList]));
  hostList = Array.from(/* @__PURE__ */ new Set([...hostList, ...remoteHostList]));
  revertSceneMap = Object.keys(sceneMap).reduce(
    (acc, cur) => {
      var _b;
      const iMap = sceneMap[cur];
      const _a2 = iMap, { path, host } = _a2, rest = __objRest(_a2, ["path", "host"]);
      let arr = [];
      if (path)
        arr = acc[path] || [];
      let sHost = "";
      if (host && typeof host === "string") {
        sHost = (_b = host == null ? void 0 : host.split("//")) == null ? void 0 : _b[1];
      }
      arr.push(__spreadProps(__spreadValues({}, rest), {
        sHost,
        sceneKey: cur
      }));
      if (path)
        acc[path] = arr;
      return acc;
    },
    {}
  );
};
var getSceneMap = () => sceneMap;
function getCDNUrlWithoutImgInfo(url) {
  var _a;
  try {
    if (!/qiandaoapp|qiandaocdn/.test(url))
      return url;
    const u = new import_url_parse.default(url);
    let styleName = "";
    const queryString = u.query;
    if (queryString.includes("Expires"))
      return url;
    if (queryString.includes("imginfo")) {
      if (queryString.includes("!")) {
        styleName = "!" + ((_a = queryString.split("!")) == null ? void 0 : _a[1]);
      }
    }
    return u.origin + u.pathname + styleName;
  } catch (e) {
    console.log("getCDNUrlWithoutImgInfo error", e);
    return url;
  }
}
function getImgInfoFromUrl(url) {
  var _a;
  const u = new import_url_parse.default(url);
  let width = 0;
  let height = 0;
  let queryString = u.query;
  if (queryString) {
    queryString = queryString.slice(1);
  }
  if (queryString.includes("imginfo")) {
    if (queryString.includes("!")) {
      queryString = (_a = queryString.split("!")) == null ? void 0 : _a[0];
    }
    let queryMap = {};
    queryString.split("&").forEach((str) => {
      const [k, v] = str.split("=");
      queryMap[k] = v;
    });
    const imgInfoString = queryMap.imginfo;
    if (imgInfoString) {
      const [$1, $2, $3, $4] = imgInfoString.match(/w(\d+)(,h(\d+))*/);
      if ($2) {
        width = +$2;
      }
      if ($4) {
        height = +$4;
      }
      console.log($1, $3);
    }
  }
  return {
    width: String(width),
    height: String(height)
  };
}

// src/lib/web/utils.ts
function getImageInfoWithBlob(file) {
  return new Promise((resolve, reject) => {
    try {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = function(e) {
        var _a, _b;
        if (typeof ((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.result) === "string") {
          img.src = (_b = e == null ? void 0 : e.target) == null ? void 0 : _b.result;
        }
      };
      reader.onerror = function(e) {
        resolve(null);
      };
      img.onload = function() {
        const { width, height } = img;
        resolve({ width, height });
      };
      img.onerror = function(e) {
        resolve(null);
      };
      if (file instanceof Blob) {
        reader.readAsDataURL(file);
      }
    } catch (e) {
      resolve(null);
    }
  });
}

// src/web.ts
var fetchPromise = (url) => __async(void 0, null, function* () {
  if (typeof fetch !== "undefined") {
    return fetch(url).then((res) => res.json());
  }
  const response = yield import_axios.default.get(url);
  return response.data;
});
var genOSSUpload = ({
  isProd = true,
  getHeaders,
  apiEndpoint,
  customApiCall
}) => (_0) => __async(void 0, [_0], function* ({
  scene = "interior-admin-v2.image",
  file,
  data
}) {
  var _a, _b, _c;
  let imageInfoSuffix = "";
  let imageWidth = 0;
  let imageHeight = 0;
  const imageInfo = yield getImageInfoWithBlob(file);
  if (imageInfo) {
    imageWidth = imageInfo.width;
    imageHeight = imageInfo.height;
    imageInfoSuffix = `?imginfo=w${imageInfo.width},h${imageInfo.height}`;
  }
  let extName = "";
  let mediaType = "";
  if (file && "name" in file) {
    extName = ((_b = (_a = file.name) == null ? void 0 : _a.split(".")) == null ? void 0 : _b.pop()) || "";
    mediaType = extName && videoExtList.includes(extName) ? "video" : "image";
  }
  scene = getRealScene(scene, isProd);
  try {
    if (file && file instanceof Blob) {
      const { default: heic2any } = yield import("heic2any");
      file = yield heic2any({
        blob: file,
        toType: "image/jpeg"
      });
    }
    extName = "jpeg";
  } catch (error) {
    if ("message" in error && !((_c = error == null ? void 0 : error.message) == null ? void 0 : _c.indexOf("already browser readable"))) {
      console.error(error);
    }
  }
  if (mediaType === "video") {
    scene = scene.replace("image", "video");
  }
  const sceneMap2 = getSceneMap();
  const sceneValue = sceneMap2[scene];
  let { host, path, bucket, uploadHost } = sceneValue;
  if (path && typeof path === "string" && path.includes(":") && data) {
    path = parsePath(path, data);
  }
  const itemList = [
    {
      bucketName: bucket,
      dir: path,
      extension: extName || "png"
    }
  ];
  const apiHost = isProd ? "https://api.qiandao.cn" : "https://dev-api.qiandao.cn";
  let header = {};
  if (getHeaders) {
    header = getHeaders();
  }
  const tempData = customApiCall ? yield customApiCall({ itemList }) : yield import_axios.default.post(
    apiEndpoint ? apiEndpoint : apiHost + "/uploader/gene-post-object-sign",
    { itemList },
    {
      withCredentials: true,
      headers: header
    }
  ).then((res) => res.data.data[0]);
  const { signature, accessId, policy, objectName } = tempData || {};
  const keyName = objectName.split("/").pop();
  const form = new FormData();
  form.append("policy", policy);
  form.append("Signature", signature);
  form.append("OSSAccessKeyId", accessId);
  form.append("key", objectName);
  if (file instanceof Blob || typeof file === "string") {
    form.append("file", file);
  }
  return new Promise((resolve, reject) => {
    try {
      if (!uploadHost || typeof uploadHost !== "string")
        return;
      import_axios.default.post(uploadHost, form, {
        headers: {
          "content-type": "multipart/form-data"
        }
      }).then(() => {
        const fullUrl = `${host}/${objectName}`;
        const ossUrl = `echotechoss://${scene}/${keyName}`;
        let ossUrlSnapshot, snapshot;
        if (mediaType === "video") {
          snapshot = `${fullUrl}${snapshotOssQuery}`;
          ossUrlSnapshot = `${ossUrl}${snapshotOssQuery}`;
        }
        resolve({
          type: mediaType,
          url: fullUrl + imageInfoSuffix,
          fullUrl: fullUrl + imageInfoSuffix,
          ossUrl: ossUrl + imageInfoSuffix,
          ossUrlSnapshot,
          snapshot,
          width: imageWidth,
          height: imageHeight
        });
      }).catch((err) => {
        reject(err);
      });
    } catch (err) {
      reject(err);
    }
  });
});
var merge = () => fetchPromise("https://config-cdn.qiandaoapp.com/oss_upload/config.json").then(
  (data) => {
    mergeConfig(data);
  }
);
var lock = null;
var isInit = false;
var init = (force = false) => __async(void 0, null, function* () {
  if (force) {
    isInit = false;
  }
  if (isInit) {
    return;
  }
  if (!lock) {
    lock = merge();
  }
  try {
    yield lock;
    lock = null;
    isInit = true;
  } catch (error) {
    lock = null;
    console.error(error);
  }
});
var decodeEchoOSSUrl = transform;
var encodeOSSUrl = encodeOssUrl;
var decodeEchoOSSUrlInterceptor = (data) => {
  return travel(data, transform);
};
var encodeEchoOSSUrlInterceptor = (data) => {
  return travel(data, encodeOssUrl);
};
var getSceneMapFn = getSceneMap;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  decodeEchoOSSUrl,
  decodeEchoOSSUrlInterceptor,
  encodeEchoOSSUrlInterceptor,
  encodeOSSUrl,
  genOSSUpload,
  getCDNUrlWithoutImgInfo,
  getImgInfoFromUrl,
  getSceneMapFn,
  init
});
//# sourceMappingURL=web.js.map